export default __webpack_public_path__ + "378df005896c9be0ca605258bafc4c1a.png";